import React from "react";

const AIBadge: React.FC = () => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "0.2rem",
      padding: "0.1rem 0.45rem",
      background: "rgba(255, 214, 165, 0.15)",
      border: "1px solid rgba(255, 214, 165, 0.35)",
      borderRadius: "10px",
      fontSize: "0.7rem",
      fontWeight: 600,
      color: "#ffd6a5",
      letterSpacing: "0.02em",
      verticalAlign: "middle",
      marginLeft: "0.4rem",
    }}
  >
    ✨ AI
  </span>
);

export default AIBadge;
